import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name:'filter'
})

export class FilterPipeGuia implements PipeTransform {

    transform(value:any,arg:any):any{

        const resultPosts=[];

        for(const guia of value){
            if(guia.nombre.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                resultPosts.push(guia);
            }
            else if(guia.modulo.toLowerCase().indexOf(arg.toLowerCase())  > -1){
                 resultPosts.push(guia);
              }

        };

        return resultPosts;

    }


}